export default __webpack_public_path__ + "static/media/stalltheadvance.6c809a7a.png";